import { useMemo } from 'react';

import { IconApplicants } from '@components/icons/applicants';
import { IconDate } from '@components/icons/date';
import { IconEmail } from '@components/icons/email';
import { IconPhone } from '@components/icons/phone';
import { FilterConfig } from '@components/table';
import { getScopedTranslate } from '@locale/translate';

import { TravellerAttributeTemplate } from 'api/attributes/requests';

import { useAttributesFilterConfig } from './use-attributes-filter-config';

export const useFilterConfig = (allowedAttributes: Array<TravellerAttributeTemplate>) => {
  const withTravellerAttributeFlag = useMemo(() => {
    return allowedAttributes.map((attribute) => ({ ...attribute, isTravellerAttribute: true }));
  }, [allowedAttributes]);

  const { isLoading, configs: attributesConfig } = useAttributesFilterConfig(
    withTravellerAttributeFlag
  );

  const config = useMemo(() => {
    const { t } = getScopedTranslate(travellerJourneyListLocale);
    let filterConfig: FilterConfig = [
      { id: 'name', type: 'text', icon: <IconApplicants />, label: t('core.fullName') },
      { id: 'email', type: 'email', icon: <IconEmail />, label: t('core.email') },
      { id: 'phone', type: 'phone_number', icon: <IconPhone />, label: t('core.phone') },
      { id: 'separator', type: 'separator' },
    ];
    if (attributesConfig.traveller.length > 0) {
      filterConfig = filterConfig.concat([
        ...attributesConfig.traveller,
        {
          id: 'separator',
          type: 'separator',
        },
      ] satisfies FilterConfig);
    }
    filterConfig.push({
      id: 'dates',
      icon: <IconDate />,
      label: t('dates'),
      type: 'category',
      fields: [
        { id: 'dateCreated', type: 'date', label: t('date_created') },
        { id: 'dateUpdated', type: 'date', label: t('date_modified') },
      ],
    });
    return filterConfig;
  }, [attributesConfig]);
  return { isLoading, config };
};

const travellerJourneyListLocale = {
  en: {
    dates: 'Dates',
    profile: 'Traveller profile',

    date_modified: 'Last modified',
    date_created: 'Created time',
  },
};
